import axios from "axios";
import axiosInstance from "../../axiosInstance";

export interface LoginUser {
  email: string;
  password: string;
}
interface LoginUserResponse {
  key: string;
}
export interface LogoutUserResponse {
  detail: string;
}


export interface UserStatusResponse {
  id: number;
  email: string;
  is_staff: boolean;
  notification_language: string;
  social_accounts: {
    provider: string;
    uid: string;
    extra_data: {
      personal_code: string;
    };
  }[];
  impersonation: {
    is_impersonated: boolean;
    admin_name: string;
    admin_id: number;
    is_admin_session: boolean;
  } | null;
}

export const loginUser = async (
  data: LoginUser
): Promise<LoginUserResponse> => {
  try {
    const response = await axiosInstance.post("/api/user/auth/login/", {
      ...data,
    });

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.message);
      throw new Error(error.message);
    } else {
      console.error("Unexpected error:", error);
      throw new Error("An unexpected error occurred.");
    }
  }
};

export const logoutUser = async (): Promise<LogoutUserResponse> => {
  try {
    const response = await axiosInstance.post("/api/user/auth/logout/");

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.message);
      throw new Error(error.message);
    } else {
      console.error("Unexpected error:", error);
      throw new Error("An unexpected error occurred.");
    }
  }
};

export const userStatus = async (): Promise<UserStatusResponse> => {
  try {
    const response = await axiosInstance.get("/api/user/status_check/");

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.status !== 403) {
        console.error("Axios error:", error.message);
      }
      throw error;
    } else {
      console.error("Unexpected error:", error);
      throw new Error("An unexpected error occurred.");
    }
  }
};
